// ----------------------------------------------------------------------

import Iconify from "../../../components/Iconify";

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Coupons",
        path: "/",
        icon: <Iconify icon="bxs:coupon" />,
      },
      {
        title: "Bookings",
        path: "/bookings",
        icon: <Iconify icon="uil:schedule" />,
      },
    ],
  },
];

export default navConfig;
